var React = require('react');

function BackIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.888 20.99a1.5 1.5 0 102.253-1.98l-2.253 1.98zM2.1 11l-1.126-.99a1.5 1.5 0 000 1.98L2.1 11zm9.04-8.01a1.5 1.5 0 10-2.252-1.98l2.253 1.98zM23.9 12.5a1.5 1.5 0 100-3v3zm-12.76 6.51l-7.914-9-2.252 1.98 7.914 9 2.253-1.98zm-7.914-7.02l7.915-9-2.253-1.98-7.914 9 2.252 1.98zM23.9 9.5H2.1v3h21.8v-3z","fill":"#000"}));
}

BackIcon.defaultProps = {"viewBox":"0 0 26 22","fill":"none"};

module.exports = BackIcon;

BackIcon.default = BackIcon;
